import React from 'react';

function QuickSubscribeThanks({ size }) {
  return (
    <React.Fragment>
      <div className={`quick-subscribe-${size}-form`}>
        <h1 className={`quick-subscribe-${size}-banner`}>Subscribe</h1>
        <hr className={`quick-subscribe-${size}-border`} />
        <p className={`quick-subscribe-${size}-lead`}>Get our newsletter delivered to<br />your electronic mailbox!</p>
        <p className={`quick-subscribe-${size}-message`}>Thanks for Subscribing!</p>
      </div>
    </React.Fragment>
  );
}

export default QuickSubscribeThanks;
